import { Logger } from '@tools/logger';

/** Dedicated Data Gatherer logger. */
export const logger = new Logger('data-gatherer');

/** ... */
export const createLogger = logger.createChild.bind(logger);
